import {
    addLayer, getBookmarkPresentationsByID,
    getLayerByName,
    removeLayer,
    setVisibleByLayerName,
    visibleLayersIncludes
} from "@/helpers/ol/ol-layer-helper";
import {
    addLayerActive,
    addLayerActiveById,
    removeLayerActive,
    removeLayerActiveElement
} from "@/helpers/ol/ol-layer-active-helper";
import {getAllBySelector, getBySelector, hideElementsBySelector, removeClassBySelector} from "@/helpers/element-helper";
import {closeInfoMenu, hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {clearMutation} from "@/helpers/tools/tools-mutation-helper";
import {clearGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper";
import {setLayerByViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";
import {clearFilter, getActiveFilter} from "@/helpers/filter/filter-helper";
import {resetFilter} from "@/helpers/filter/filter-settings-helper";

export function initLayerMenuGroupItemClicks() {

    getBySelector('layer-menu').addEventListener('change', (event) => {
        if(event.target.type === 'checkbox') {

            const element = event.target.closest('layer-menu-group-item')
            if(element) {
                changeLayerMenuGroupItem(event, element)
            } else {
                const element = event.target.closest('layer-menu-group-merged')
                if(element) {
                    const childElement = element.querySelector('layer-menu-button-info')
                    if(element.querySelector('input').checked) {
                        childElement.classList.remove('d-none')

                        if(element.closest('layer-menu-overview')) {
                            const layerMenuActiveItem = getBySelector('layer-menu-active input[value="' + event.target.value + '"]')
                            if(layerMenuActiveItem) {
                                layerMenuActiveItem.checked = true
                            }
                        }
                    } else {
                        childElement.classList.add('d-none')
                        if(element.closest('layer-menu-active')) {
                            console.log('clearr')

                            getBySelector('layer-menu-overview input[value="' + event.target.value + '"]').checked = false
                        }
                    }
                }
            }
        }
    })
    getBySelector('layer-menu').addEventListener('click', (event) => {
        if(event.target.type === 'radio') {
            const element = event.target.closest('layer-menu-group-item')

            let isRadioUnset = false

            let layerMenuGroup = element.closest('layer-menu-group')
            if(layerMenuGroup) {
                layerMenuGroup.querySelectorAll('layer-menu-group-item').forEach(childElement => {

                    if(element.dataset.id !== childElement.dataset.id
                    ) {
                        childElement.querySelector('layer-menu-button-info').classList.add('d-none')
                        childElement.querySelector('layer-menu-active-item-zoom').classList.add('d-none')
                        visibleLayersIncludes(childElement.dataset.id, false)
                        removeLayerActive(childElement.dataset.id)

                        const activeFilter = getActiveFilter()
                        if(activeFilter && activeFilter.BookmarkPresentationID === parseInt(childElement.dataset.id)) {
                            resetFilter()
                        }
                    } else {
                        const layer = getLayerByName(childElement.dataset.id)
                        if(layer && layer.getVisible()) {
                            isRadioUnset = true
                        }
                    }
                })
            }

            changeLayerMenuGroupItem(event, element, isRadioUnset)
            setLayerByViewResolution()
        }
    })
}

export function changeLayerMenuGroupItem(event, element, isRadioUnset = false) {

    const bookmarkPresentationID = element.dataset.bookmarkPresentationId
    const label = element.dataset.label
    if(event.srcElement.classList.contains('layer-over-view-domain-list-checkbox')) {
        return
    }

    const input = element.querySelector('input')
    const id = input.value
    if(isRadioUnset) {
        input.checked = false
    }
    let checked = input.checked

    let zoomElement = element.querySelector('layer-menu-active-item-zoom')
    let infoElement = element.querySelector('layer-menu-button-info')
    let layerMenuButtonZoomScale = element.querySelector('layer-menu-button-zoom-scale')

    if(!infoElement || !zoomElement || !layerMenuButtonZoomScale)  {
        return
    }

    if (checked) {
        infoElement.classList.remove('d-none')
    } else {
        infoElement.classList.add('d-none')
        zoomElement.classList.add('d-none')

        clearMutation(id)

        const activeFilter = getActiveFilter()
        if(activeFilter && activeFilter.BookmarkPresentationID === parseInt(id)) {
            resetFilter()
            closeInfoMenu()
        }

        delete window.clickMapPixel
    }

    if(bookmarkPresentationID) {
        addLayer(id, checked, undefined, false, element)

        if(!checked) {
            window.layersActive = window.layersActive.filter(item => item !== id)
        } else {
            addLayerActiveById(id)
        }
    } else {
        if(checked) {

            if(element.dataset.merged !== 'true') {
                addLayerActive(id, label, checked)
            }

        } else {
            removeLayerActive(id)
        }

        addLayer(id, checked, undefined, false, element)
    }
}

export function removeAllActiveClasses() {


}

export function blockUnBlockZoomElement(id, element, checked) {
    const bookmarkPresentation = getBookmarkPresentationsByID(id)
    if(element && bookmarkPresentation && checked) {
        let zoomElement = element.querySelector('layer-menu-active-item-zoom')
        // if (bookmarkPresentation.bbox || bookmarkPresentation.Type === 'WFS') {
            zoomElement.classList.remove('d-none')
        // }
    }
}
